import { request } from "../utils/request"


/**
 * 查询监测点历史数据数据
 * @param params 
 * @returns 
 */
export const getChartData = (pointId: number, params?: { start?: Date, end?: Date }) => {
    return request.get(`/data/${pointId}`, { params })
}

/**
 * fetch 分页数，返回的数据均关联企业
 * @param params 
 * @returns 
 */
export const getData = (params: { cmp?: number, proj?: number, page: number, limit: number }) => {
    return request.get('/data', { params })
}

/**
 * 分页历史报警数据
 * @param params 
 * @returns 
 */
export const getWarningData = (params: { cmp?: number, proj?: number, page: number, limit: number }) => {
    return request.get('/data/warning/list', { params })
}

/**
 * 响应报警
 * @param params 
 * @returns 
 */
export const handleWarning = (data: { id: number, response?: string }) => {
    return request.post('/data/warning/handle', data)
}